"use client"
// import { AlertTriangle } from 'lucide-react';

interface DendromapLoaderProps {
  message?: string;
  size?: 'sm' | 'md' | 'lg';
}

export function DendromapLoader({
  message = "Chargement des alertes...",
  size = 'md'
}: DendromapLoaderProps) {
  const sizeClasses = {
    sm: 'w-8 h-8',
    md: 'w-12 h-12',
    lg: 'w-16 h-16'
  };

  const textSizeClasses = {
    sm: 'text-sm',
    md: 'text-base',
    lg: 'text-lg'
  };

  return (
    <div className="flex flex-col items-center justify-center p-8 space-y-4">
      {/* Animated Dendromap Logo */}
      <div className="relative">
        <img src="/images/logos/white.svg" alt="Dendromap" width={50} height={50} />
      </div>

      {/* Loading message */}
      <div className="text-center">
        <p className={`${textSizeClasses[size]} text-gray-600 dark:text-gray-400 font-medium`}>
          {message}
        </p>
        <div className="flex items-center justify-center mt-2 space-x-1">
          <div className="w-2 h-2 bg-green-500 rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></div>
          <div className="w-2 h-2 bg-green-500 rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></div>
          <div className="w-2 h-2 bg-green-500 rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></div>
        </div>
      </div>
    </div>
  );
}
